export const UPDATE_SELECTED_MERCHANTS = 'MERCHANT_SELECTOR/UPDATE_SELECTED';
export const TOGGLE_SELECTOR_OPEN = 'MERCHANT_SELECTOR/TOGGLE_SELECTOR_OPEN';

export function updateSelectedMerchants(merchants, isAllSelected) {
    return {
        isAllSelected,
        merchants,
        type: UPDATE_SELECTED_MERCHANTS
    };
}

export function toggleSelectorOpen(isClosed, selectedMerchants) {
    return {
        isClosed,
        selectedMerchants,
        type: TOGGLE_SELECTOR_OPEN
    };
}

export function generateMerchantIdsString(merchants = []) {
    return merchants.map((merchant = {}) => merchant.merchantId).join();
}
